import { getSessionStorage, setSessionStorage } from '@tcp/core/src/utils';
import isEmpty from 'lodash/isEmpty';
import logger from '@tcp/core/src/utils/loggerInstance';
import { SECTION_MODE } from '../SinglePageCheckout.constants';
import { checkValidShipmentMethod } from '../SinglePageCheckout.utils';
import { SHIPPING_FORM } from './Shipping.constants';

export const isAddressSaved = (address) => !!(address && address.addressId);

export const formatPayloadForMelissa = (payload = {}) => {
  const { addressLine1, addressLine2, zipCode, primary, formName, ...otherPayload } = payload;
  return {
    ...otherPayload,
    ...{
      address1: addressLine1,
      address2: addressLine2,
      zip: zipCode,
      primary: primary ? 'true' : 'false',
      formName,
    },
  };
};

/**
 * Check whether shipment method should be auto updated
 *
 * For edit mode, if invalid shipmentMethod then auto update to valid.
 * For add mode, auto update to default or first shipmentMethod.
 *
 * @param - {sectionMode, shipmentMethods, currentShipmentId}
 * @returns flag to auto update shipment method selection
 */
export const shouldAutoUpdateMethodSelection = ({
  sectionMode,
  shipmentMethods,
  currentShipmentId,
}) => {
  // Check if currentShipmentId exists in list of available shipment methods
  const isMethodUnavailable =
    currentShipmentId && !checkValidShipmentMethod(currentShipmentId, shipmentMethods);
  // Check if auto-update of selected method is required based on mode(ADD/EDIT) of section
  const isMethodInvalidForAddEditModes =
    (isMethodUnavailable && sectionMode === SECTION_MODE.SECTION_EDIT_MODE) ||
    (isMethodUnavailable && sectionMode === SECTION_MODE.SECTION_ADD_MODE) ||
    (!currentShipmentId && sectionMode === SECTION_MODE.SECTION_ADD_MODE);
  return !!(shipmentMethods && shipmentMethods.length && isMethodInvalidForAddEditModes);
};

export const setShippingFormValuesInSS = (savedContactInfo) => {
  setSessionStorage({ key: SHIPPING_FORM, value: JSON.stringify(savedContactInfo) });
};

export const getShippingFormValuesFromSS = () => {
  try {
    let savedContactFormData = getSessionStorage(SHIPPING_FORM);
    savedContactFormData = (savedContactFormData && JSON.parse(savedContactFormData)) || {};
    return savedContactFormData;
  } catch (e) {
    logger.error('Error in getContactFormValuesFromSS', e);
    return {};
  }
};

export const getPhoneNumberValue = (isLoggedIn, contactFormValuesFromSS, loggedInUser) => {
  if (isLoggedIn && !contactFormValuesFromSS?.phoneNumber) {
    return { ...contactFormValuesFromSS, phoneNumber: loggedInUser?.phoneNumber };
  }
  return { ...contactFormValuesFromSS };
};

export const getContactFormValues = ({
  isLoggedIn,
  loggedInUser,
  contactFormValuesFromSS,
  shippingContactInfo: {
    emailAddress: savedEmailAddress,
    phoneNumber: savedPhoneNumber,
    smsSignUp: savedSmsSignUp,
    emailSignUp: savedEmailSignUp,
  },
}) => {
  let initValues = {};
  let contactFormDetails = {};
  if (isLoggedIn) {
    initValues = { ...initValues, emailAddress: loggedInUser?.emailAddress };
    if (loggedInUser?.phoneNumber) {
      initValues = { ...initValues, phoneNumber: loggedInUser?.phoneNumber };
    }
  }
  if (savedEmailAddress) {
    initValues = { ...initValues, emailAddress: savedEmailAddress };
  }
  if (savedPhoneNumber) {
    initValues = { ...initValues, phoneNumber: savedPhoneNumber };
  }
  if (savedSmsSignUp) {
    initValues = { ...initValues, smsSignUp: savedSmsSignUp };
  }
  if (savedEmailSignUp) {
    initValues = { ...initValues, emailSignUp: savedEmailSignUp };
  }
  if (!isEmpty(contactFormValuesFromSS)) {
    contactFormDetails = { ...contactFormValuesFromSS };
    initValues = { ...initValues, ...contactFormDetails };
  }
  return initValues;
};
